import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BuyerLayout from '@/layouts/BuyerLayout';
const OrderPayment = lazy(() => import('@/pages/OrderPayment'));
const OrderDetail = lazy(() => import('@/pages/OrderDetail'));
const ClaimCenter = lazy(() => import('@/pages/ClaimCenter'));
const ClaimDetail = lazy(() => import('@/pages/ClaimDetail'));
const Profile = lazy(() => import('@/pages/Profile'));
const LoginPage = lazy(() => import('@/pages/LoginPage'));
const RegisterPage = lazy(() => import('@/pages/RegisterPage'));
import Home from '@/pages/Home';
const ProductDetail = lazy(() => import('@/pages/ProductDetail'));
const OrderCreate = lazy(() => import('@/pages/OrderCreate'));
const InquiryCreate = lazy(() => import('@/pages/InquiryCreate'));
const InquiryList = lazy(() => import('@/pages/InquiryList'));
const QuotationDetail = lazy(() => import('@/pages/QuotationDetail'));
const MessagesPage = lazy(() => import('@/pages/MessagesPage'));
const BuyerJourney = lazy(() => import('@/pages/BuyerJourney'));
const BuyerInquiryProgress = lazy(() => import('@/pages/BuyerInquiryProgress'));
import RequireAuth from '@/components/buyer/RequireAuth';
const ShareOrderPage = lazy(() => import('@/pages/ShareOrderPage'));
const ShareQuotationPage = lazy(() => import('@/pages/ShareQuotationPage'));

export default function AppRouter() {
  return (
    <Suspense fallback={<div role="status" style={{ padding: 32, textAlign: 'center' }}>加载中 / Loading…</div>}>
    <Routes>
      {/* 登录页：置于 BuyerLayout 分组之外，不带底部 Tab 栏与顶部 AppBar */}
      <Route path="/buyer/login" element={<LoginPage />} />
    <Route path="/buyer/register" element={<RegisterPage />} />

      {/* 免登录分享页面 */}
      <Route
        path="/share/:token"
        element={
          <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>}>
            <ShareOrderPage />
          </Suspense>
        }
      />

      {/* 免登录报价单分享查看页 */}
      <Route
        path="/buyer/share-quotation/:token"
        element={
          <Suspense fallback={<div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>}>
            <ShareQuotationPage />
          </Suspense>
        }
      />

      {/* 浏览免登录：首页与商品详情仍带底部 Tab 栏，但不要求登录 */}
      <Route element={<BuyerLayout />}>
        <Route path="/buyer/home" element={<Home />} />
        <Route path="/buyer/experience" element={<RequireAuth blockUnauthenticated><BuyerJourney /></RequireAuth>} />
        <Route path="/buyer/products/:id" element={<ProductDetail />} />
      </Route>

      {/* 交易需登录：用 RequireAuth 包裹，未登录自动跳转登录页 */}
      <Route element={<RequireAuth><BuyerLayout /></RequireAuth>}>
        <Route path="/buyer/orders" element={<OrderPayment />} />
        <Route path="/buyer/orders/:orderId" element={<OrderDetail />} />
        <Route path="/buyer/order-create/:id" element={<OrderCreate />} />
        <Route path="/buyer/inquiry/:id" element={<InquiryCreate />} />
        <Route path="/buyer/inquiry/new" element={<InquiryCreate />} />
        <Route path="/buyer/inquiry/edit/:editId" element={<InquiryCreate />} />
        <Route path="/buyer/inquiries" element={<InquiryList />} />
        <Route path="/buyer/inquiries/:id" element={<BuyerInquiryProgress />} />
        <Route path="/buyer/quotation/:id" element={<QuotationDetail />} />
        <Route path="/buyer/messages" element={<MessagesPage />} />
        <Route path="/buyer/claims" element={<ClaimCenter />} />
        <Route path="/buyer/claims/:id" element={<ClaimDetail />} />
        <Route path="/buyer/profile" element={<Profile />} />
      </Route>

      {/* 全局兜底：未匹配任何路由时（含 /buyer 根路径）跳转公共首页，无需登录 */}
      <Route path="*" element={<Navigate to="/buyer/home" replace />} />
    </Routes>
    </Suspense>
  );
}
